import { UserFormSchema } from "../../../common/components/user-inv-modal/api/schema";
import { WalkthroughStep } from "../../../common/components/walkthrough/api/type";
import { CivilStatus } from "../../../common/enums/civil-status";
import { Gender } from "../../../common/enums/gender";
import { PagedUserModel, UserModel } from "../../users-facility/api/types";

export const facilityUserStep: WalkthroughStep[] = [
  {
    id: "dropdown-wrapper",
    title: "Filter",
    content: "Select a filter first to preview the user list.",
    touchIconVerticalPosition: "flex-end",
    touchIconHorizontalPosition: "center",
    anchorOriginVertical: "bottom",
    anchorOriginHorizontal: "center",
    transformVertical: "top",
    transformHorizontal: "center",
  },
  {
    id: "wt-table",
    title: "Facility Users",
    content: "This table shows all users assigned to the facility.",
    touchIconVerticalPosition: "flex-end",
    touchIconHorizontalPosition: "bottom",
    anchorOriginVertical: "center",
    anchorOriginHorizontal: "center",
    transformVertical: "top",
    transformHorizontal: "center",
  },
  {
    id: "wt-invite-user",
    title: "Invite User",
    content: "Invite a new user by clicking this button.",
    touchIconVerticalPosition: "center",
    touchIconHorizontalPosition: "center",
    anchorOriginVertical: "bottom",
    anchorOriginHorizontal: "center",
    transformVertical: "top",
    transformHorizontal: "center",
  },
  {
    id: "wt-invite-dialog",
    title: "Invite User",
    content:
      "Search by name or email address to check if the user already exists. If not, you can create a new account",
    touchIconVerticalPosition: "center",
    touchIconHorizontalPosition: "flex-end",
    anchorOriginVertical: "bottom",
    anchorOriginHorizontal: "center",
    transformVertical: "top",
    transformHorizontal: "center",
  },
  {
    id: "wt-invite-dialog-2",
    title: "Invite User",
    content:
      "Select the matching active user to proceed, or click Ignore to invite a new one if there are no matches.",
    touchIconVerticalPosition: "center",
    touchIconHorizontalPosition: "flex-end",
    anchorOriginVertical: "bottom",
    anchorOriginHorizontal: "center",
    transformVertical: "top",
    transformHorizontal: "center",
  },
  {
    id: "wt-assign-role-and-product",
    title: "Invite User",
    content: "Update the user's info if needed, then click Next to proceed.",
    touchIconVerticalPosition: "center",
    touchIconHorizontalPosition: "flex-start",
    anchorOriginVertical: "top",
    anchorOriginHorizontal: "left",
    transformVertical: "bottom",
    transformHorizontal: "left",
  },
  {
    id: "wt-assign-role-and-product-2",
    title: "Invite User",
    content:
      "Assign the user's role and products, the save. Login details will be sent to their email.",
    touchIconVerticalPosition: "flex-end",
    touchIconHorizontalPosition: "center",
    anchorOriginVertical: "top",
    anchorOriginHorizontal: "center",
    transformVertical: "top",
    transformHorizontal: "center",
  },
  {
    id: "wt-assign-role-and-product-3",
    title: "Invite User",
    content:
      "Assign the user's role and products, the save. Login details will be sent to their email.",
    touchIconVerticalPosition: "flex-end",
    touchIconHorizontalPosition: "center",
    anchorOriginVertical: "top",
    anchorOriginHorizontal: "center",
    transformVertical: "top",
    transformHorizontal: "center",
  },
  {
    id: "wt-table",
    title: "Invite User",
    content: "The new user will now appear in the list.",
    touchIconVerticalPosition: "flex-end",
    touchIconHorizontalPosition: "bottom",
    anchorOriginVertical: "center",
    anchorOriginHorizontal: "center",
    transformVertical: "top",
    transformHorizontal: "center",
  },
  {
    id: "wt-search-bar",
    title: "Search",
    content:
      "Click the search field → type the name of a user (full or partial). Press Enter or click the magnifying glass to filter.",
    touchIconVerticalPosition: "center",
    touchIconHorizontalPosition: "center",
    anchorOriginVertical: "bottom",
    anchorOriginHorizontal: "left",
    transformVertical: "top",
    transformHorizontal: "left",
  },
  {
    id: "wt-ellipsis",
    title: "Manager User",
    content:
      "Click the ellipsis to manage the user (edit, reset, password, lock, or delete).",
    touchIconVerticalPosition: "center",
    touchIconHorizontalPosition: "center",
    anchorOriginVertical: "top",
    anchorOriginHorizontal: "right",
    transformVertical: "bottom",
    transformHorizontal: "left",
  },
  {
    id: "wt-button",
    title: "Walkthrough Icon",
    content:
      "Tip: If you accidentally close this walkthrough, just click this ℹ️(info) icon anytime to start it again from the beginning.",
    touchIconVerticalPosition: "center",
    touchIconHorizontalPosition: "center",
    anchorOriginVertical: "bottom",
    anchorOriginHorizontal: "left",
    transformVertical: "top",
    transformHorizontal: "left",
  },
];

const dummyUsers: UserModel[] = [
  {
    id: "u_001",
    firstName: "Juan M I",
    lastName: "Delacruz",
    email: "delacruz@mailinator.com",
    emailConfirmed: true,
    middleName: "",
    suffix: "",
    civilStatus: 0,
    gender: 0,
    twoFactorEnabled: false,
  },
  {
    id: "u_002",
    firstName: "JUAN MANGKAL",
    lastName: "SR DELA CRUZ",
    email: "GG@mailinator.com",
    emailConfirmed: false,
    middleName: "",
    suffix: "",
    civilStatus: 0,
    gender: 0,
    twoFactorEnabled: false,
  },
  {
    id: "u_003",
    firstName: "Juan",
    lastName: "Dela Cruz",
    email: "juandelacruz123@mailinator.com",
    emailConfirmed: false,
    middleName: "",
    suffix: "",
    civilStatus: 0,
    gender: 0,
    twoFactorEnabled: false,
  },
  {
    id: "u_004",
    firstName: "Juan",
    lastName: "Dela Cruz",
    email: "superadmin@mailinator.com",
    emailConfirmed: true,
    middleName: "",
    suffix: "",
    civilStatus: 0,
    gender: 0,
    twoFactorEnabled: false,
  },
  {
    id: "u_005",
    firstName: "Juan",
    lastName: "Dela Cruz",
    email: "qletzsteven11@gmail.com",
    emailConfirmed: false,
    middleName: "",
    suffix: "",
    civilStatus: 0,
    gender: 0,
    twoFactorEnabled: false,
  },
  {
    id: "u_006",
    firstName: "juan",
    lastName: "carlo",
    email: "juancarlo@mailinator.com",
    emailConfirmed: false,
    middleName: "",
    suffix: "",
    civilStatus: 0,
    gender: 0,
    twoFactorEnabled: false,
  },
  {
    id: "u_007",
    firstName: "Maria",
    lastName: "Dela Cruz",
    email: "mariadelacruz@mailinator.com",
    emailConfirmed: false,
    middleName: "",
    suffix: "",
    civilStatus: 0,
    gender: 1,
    twoFactorEnabled: false,
  },
  {
    id: "u_008",
    firstName: "Carlos",
    lastName: "Dela Cruz",
    email: "carlosdc@mailinator.com",
    emailConfirmed: true,
    middleName: "",
    suffix: "",
    civilStatus: 0,
    gender: 0,
    twoFactorEnabled: false,
  },
  {
    id: "u_009",
    firstName: "Ana",
    lastName: "Cruz",
    email: "anacruz@mailinator.com",
    emailConfirmed: false,
    middleName: "",
    suffix: "",
    civilStatus: 0,
    gender: 1,
    twoFactorEnabled: false,
  },
  {
    id: "u_010",
    firstName: "Pedro",
    lastName: "Cruz",
    email: "pedrocruz@mailinator.com",
    emailConfirmed: false,
    middleName: "",
    suffix: "",
    civilStatus: 0,
    gender: 0,
    twoFactorEnabled: false,
  },
  {
    id: "u_011",
    firstName: "Jose",
    lastName: "Dela Cruz",
    email: "josedelacruz@mailinator.com",
    emailConfirmed: false,
    middleName: "",
    suffix: "",
    civilStatus: 0,
    gender: 0,
    twoFactorEnabled: false,
  },
];

export const getDummyPaged = (
  pageNumber: number,
  pageSize: number
): PagedUserModel => {
  const start = (pageNumber - 1) * pageSize;
  const items = dummyUsers.slice(start, start + pageSize);
  return {
    items,
    totalItems: dummyUsers.length,
    pageNumber,
    pageSize,
    allowedUserCount: 100,
  };
};

export const dummyPagedUsers: PagedUserModel = {
  items: [
    {
      id: "u_001",
      photoUrl: undefined,
      email: "john.doe@example.com",
      emailConfirmed: true,
      lastName: "Doe",
      firstName: "John",
      middleName: "Q",
      fullName: "John Q Doe",
      birthDate: "1990-05-20",
      prefix: "",
      suffix: "",
      phoneNumber: "09171234567",
      customName: "",
      products: [],
      clients: [],
      civilStatus: CivilStatus.Single,
      gender: Gender.Male,
      roles: ["User"],
      role: {
        id: "role-user",
        name: "User",
        displayName: "Standard User",
        role: "User",
      },
      lastLoginAt: new Date(),
      adminLockingReason: undefined,
      isAdminLocked: undefined,
      twoFactorEnabled: false,
      unreadNotifications: 0,
      facilities: [],
      isDefaultPassword: true,
    },
    {
      id: "u_002",
      photoUrl: undefined,
      email: "jane.smith@example.com",
      emailConfirmed: true,
      lastName: "Smith",
      firstName: "Jane",
      middleName: "A",
      fullName: "Jane A Smith",
      birthDate: "1985-11-15",
      prefix: "",
      suffix: "",
      phoneNumber: "09981234567",
      customName: "",
      products: [],
      clients: [],
      civilStatus: CivilStatus.Married,
      gender: Gender.Female,
      roles: ["User"],
      role: {
        id: "role-admin",
        name: "Admin",
        displayName: "Facility Admin",
        role: "Admin",
      },
      lastLoginAt: new Date(),
      adminLockingReason: undefined,
      isAdminLocked: undefined,
      twoFactorEnabled: true,
      unreadNotifications: 5,
      facilities: [],
      isDefaultPassword: false,
    },
  ],
  pageNumber: 1,
  pageSize: 10,
  totalItems: 3,
  allowedUserCount: 999,
};

export const dummyUserForm: UserFormSchema = {
  id: "u_001",
  firstName: "John",
  lastName: "Doe",
  middleName: "Q",
  suffix: "",
  prefix: "",
  customName: "",
  email: "john.doe@example.com",
  civilStatus: CivilStatus.Single,
  gender: Gender.Male,
  productCode: "PRD-001",
  facilityCode: "FAC-001",
  role: {
    id: "role-user",
    name: "User",
    displayName: "Standard User",
    role: "User",
  },
  clientIds: ["CL-1001", "CL-1002"],
  birthDate: "1990-05-20",
  photoUrl: undefined,
  isDefaultPassword: true,
};
